import emailjs from "emailjs-com";
import React from 'react';
import '../css/Contato.css';
import linkedin from '../img/linkedin.png';
import whatz from '../img/whatz.png';
import email from '../img/email.png';
import github from '../img/github.png';

// import contactImg from "./img/about-9.jpg"
function Contato() {

  function enviarEmail(e) {
    e.preventDefault();

    emailjs.sendForm('gmailMessage', 'template_0mb0r89', e.target, 'user_zbR75d2ATavrCwjrUM6pU')
      .then((result) => {
        alert('Mensagem enviada com sucesso! 👍')
      }, (error) => {
        alert(error.message)
      });
    e.target.reset();
  }
  return (
    <div className="contact component__space" id="Contato">
      <div className="row">
        <div className="col__2">
          <div className="contact__box">
            <div className="contact__meta">
              <h1 className="hire__text">Entre em contato</h1>
              {/* <p className="hire__text white">Estou dispinível para trabalhos. Entre em contato pelo celular:</p> */}
              {/* <p className="hire__text white"><strong>12 98143-8324</strong> ou email <strong>henrique.junqueira@engenharia.ufjf.br</strong></p> */}
            </div>
            <form onSubmit={enviarEmail}>
              <div className="input__box">
                <input type="text" className="contact name" placeholder="Nome" name="name" />
                <input type="text" className="contact email" placeholder="Email" name="email" />
                <input type="text" className="contact subject" placeholder="Assunto" name="assunto" />
                <textarea name="mensagem" id="message" placeholder="Mensagem" ></textarea>
                <button className="btn contact pointer" type="submit">Enviar</button>
              </div>
            </form>
          </div>
        </div>
        <div className="col__2 info">
          <div className=" c-info-item">
            <a href="https://api.whatsapp.com/send?phone=5512981438324&text=Ol%C3%A1%20Henrique%2C%20vim%20atrav%C3%A9s%20do%20seu%20portf%C3%B3lio">
              <img src={whatz} alt="" className="contact__img" />
            </a>
            (12) 98143-8324
          </div>
          <div className=" c-info-item">
            <a href="https://www.linkedin.com/in/henriquejunqueirabraga/">
              <img src={linkedin} alt="" className="contact__img" />
            </a>
            linkedin.com/in/henriquejunqueirabraga
          </div>
          <div className=" c-info-item">
            <a href='mailto:henrique.junqueira@engenharia.ufjf.br'>
              <img src={email} alt="" className="contact__img" />
            </a>
            henrique.junqueira@engenharia.ufjf.br
            {/* <img src={contactImg} alt="" className="contact__img" /> */}
          </div>
          <div className=" c-info-item">
            <a href="https://github.com/henriquejbraga">
              <img src={github} alt="" className="contact__img" />
            </a>
            github.com/henriquejbraga
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contato